
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ProgressBar } from './ProgressBar';
import { Circle, Star, Target } from "lucide-react";

interface FoulsLocationCardProps {
  title: string;
  stats: {
    average: string;
    total?: number;
    mostFouls?: { team: string; value: number };
    leastFouls?: { team: string; value: number };
    overUnderStats: {
      threshold: number;
      over: string;
      under: string;
    }[];
  };
  color?: string;
}

export const FoulsLocationCard: React.FC<FoulsLocationCardProps> = ({
  title,
  stats,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-black text-lg">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            {stats.total && (
              <div className="flex items-center gap-2">
                <Circle className="h-4 w-4 text-orange-500" />
                <span className="text-black">Total: {stats.total}</span>
              </div>
            )}
            
            <div className="flex items-center gap-2">
              <Circle className="h-4 w-4 text-orange-500" />
              <span className="text-black">Average: {stats.average}</span>
            </div>

            {stats.mostFouls && (
              <div className="flex items-center gap-2">
                <Star className="h-4 w-4 text-yellow-500" />
                <span className="text-black">Most: {stats.mostFouls.team} ({stats.mostFouls.value.toFixed(2)})</span>
              </div>
            )}

            {stats.leastFouls && (
              <div className="flex items-center gap-2">
                <Target className="h-4 w-4 text-blue-500" />
                <span className="text-black">Least: {stats.leastFouls.team} ({stats.leastFouls.value.toFixed(2)})</span>
              </div>
            )}
          </div>

          <div className="space-y-2">
            {stats.overUnderStats.map(({ threshold, over }) => (
              <div key={threshold} className="flex justify-between items-center gap-4">
                <span className="text-sm text-black w-24">Over {threshold}</span>
                <div className="flex-1">
                  <ProgressBar percentage={over} color="bg-orange-500" />
                </div>
                <span className="text-sm font-medium w-16 text-right text-black">{over}%</span>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
